import axios from "axios";
import utilityfun from "./helpers/utilityfun";
export default class ApiClass {

    // LINKS
    static nodeUrl = utilityfun.getSubDomainUrl();

    //********************************** Delete api ************************************************** */

    static deleteRequest(apiUrl, isToken = true, headers = null, params = null) {
        return axios.delete(this.nodeUrl + apiUrl, this.config(isToken, headers, params)).then(result => {
            return result
        }).catch(error => {
            if (error.response?.status == 401) {
                this.unauthenticateRedirect();
            }
        })
    }

    //****************************** Configrations of header and parameters ****************************** */

    static config(isToken = true, headers = null, parameters = null) {
        let defaultHeaders = {
            Accept: "application/json"
        };
        let merge = {};
        if (isToken) {
            let token = { Authorization: "Bearer " + localStorage.getItem("token") }
            merge = Object.assign(defaultHeaders, token)
        }
        merge = Object.assign(defaultHeaders, headers)
        return {
            headers: merge,
            params: parameters
        }
    }

    //******************************** if the unautherntication Error..... ************************************* */

    static unauthenticateRedirect() {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        window.location.replace('/login');
    }

    // node Api 

    static getNodeRequest(apiUrl, isToken = true, headers = null, params = null) {
        return axios.get(this.nodeUrl + apiUrl, this.config(isToken, headers, params)).then(result => {
            return result;
        }).catch(error => {
            if (error.response?.status == 401) {
                this.unauthenticateRedirect();
            }
        });
    }
    // POst
    static postNodeRequest(apiUrl, isToken = true, formData = null, headers = null, params = null) {
        return axios.post(this.nodeUrl + apiUrl, formData, this.config(isToken, headers, params)).then(result => {
            return result;
        }).catch(error => {
            if (error.response?.status == 401) {
                this.unauthenticateRedirect();
            }
        });
    }
    //******************* form data in json format ************************ */

    static updateRequest(apiUrl, isToken = true, formData = null, headers = null, params = null) {

        return axios.put(this.nodeUrl + apiUrl, formData, this.config(isToken, headers, params)).then(result => {
            return result;
        }).catch(error => {
            if (error.response?.status == 401) {
                this.unauthenticateRedirect();
            }
        });
    }


}